import { createAuthClient } from 'better-auth/react';

// Zelfde origin: Apache (of de Vite-proxy) stuurt /api/auth door naar de backend.
export const authClient = createAuthClient();
